import React, { useEffect, useContext, useState, useRef } from 'react'
import { Link as RouterLink, useHistory } from 'react-router-dom';

import Moment from 'moment'

import LanguageContext from "../../../contexts/LanguageContext"

import { Box, Hidden, CircularProgress, Button } from '@mui/material'

import noCompletionChartIcon from "../../../images/noCompletionChartIcon.svg"

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';
import { Line, getDatasetAtEvent } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
);

let actFocusIndex = null
function scale(number, inMin, inMax, outMin, outMax) {
  return (number - inMin) * (outMax - outMin) / (inMax - inMin) + outMin;
}
function hexToRgb(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
}
/* D7 review 02/09 (style Figma) : aire remplie en permanence sous chaque
 * courbe. Le survol garde son degrade plus marque, le repos garde ce voile. */
function fondDoux(hex) {
  const rgb = hexToRgb(hex)
  return rgb ? "rgba("+rgb.r+","+rgb.g+","+rgb.b+",0.14)" : "transparent"
}

function getGradient(ctx, chartArea, dataset, chart) {
  let topValue = scale(dataset.data[dataset.data.length - 1], chart.scales['y'].min, chart.scales['y'].max, chartArea.bottom, chartArea.top)
  let rgbColor = hexToRgb(dataset.borderColor)
  //let calcAngle = (chartArea.right - chartArea.left) / 2
  //console.log(calcAngle)
  let gradient = ctx.createLinearGradient(
    0,
    chartArea.bottom,
    0,
    //chartArea.top
    topValue
  );
  gradient.addColorStop(1, "rgba("+rgbColor.r+","+rgbColor.g+","+rgbColor.b+",0.5)");
  gradient.addColorStop(0, "rgba(255,255,255,0)");
  return gradient;
}
const options = {
  responsive: true,
  maintainAspectRatio: false,
  onClick: (e, activeEls) => {
    if (activeEls[0]) {
      let datasetIndex = activeEls[0].datasetIndex;
      if (actFocusIndex !== datasetIndex) {
        if (actFocusIndex !== null) {
          e.chart.data.datasets[actFocusIndex].backgroundColor = fondDoux(e.chart.data.datasets[actFocusIndex].borderColor)
        }
        e.chart.data.datasets[datasetIndex].backgroundColor = getGradient(e.chart.ctx, e.chart.chartArea, e.chart.data.datasets[datasetIndex], e.chart);
        actFocusIndex = datasetIndex
        e.chart.update()
      }
    } else {
      if (actFocusIndex !== null) {
        e.chart.data.datasets[actFocusIndex].backgroundColor = fondDoux(e.chart.data.datasets[actFocusIndex].borderColor)
        actFocusIndex = null
        e.chart.update()
      }
    }
  },
  onHover: (e, activeEls) => {
    if (activeEls[0]) {
      let datasetIndex = activeEls[0].datasetIndex;
      if (actFocusIndex !== datasetIndex) {
        if (actFocusIndex !== null) {
          e.chart.data.datasets[actFocusIndex].backgroundColor = fondDoux(e.chart.data.datasets[actFocusIndex].borderColor)
        }
        e.chart.data.datasets[datasetIndex].backgroundColor = getGradient(e.chart.ctx, e.chart.chartArea, e.chart.data.datasets[datasetIndex], e.chart);
        actFocusIndex = datasetIndex
        e.chart.update()
      }
    } else {
      if (actFocusIndex !== null) {
        e.chart.data.datasets[actFocusIndex].backgroundColor = fondDoux(e.chart.data.datasets[actFocusIndex].borderColor)
        actFocusIndex = null
        e.chart.update()
      }
    }
  },
  plugins: {
    legend: {
      // D7 review 02/09 : legende a points, conforme Figma
      display:true,
      position:"top",
      align:"end",
      labels : {
        usePointStyle : true,
        pointStyle : "circle",
        boxWidth : 7,
        boxHeight : 7,
        color : "#0A0A0B",
        font : { family : "Questrial", size : 13 },
      },
    },
    title: {
      display: true,
      align : "start",
      position:"top",
      color : "#000000",
      padding : {
        bottom : 25,
        top : 0,
      },
      font : {
        family : "Questrial",
        weight:400,
        size: 23,
      },
    },
    tooltip : {
      backgroundColor:"white",
      titleColor:"rgba(0, 0, 0, 0.6)",
      titleFont : {
        family : "Questrial",
        weight:400,
      },
      bodyColor:"black",
      bodyFont : {
        family : "Questrial",
        weight:400,
      },
      boxPadding : 3,
      animation: false,
      borderWidth: 1,
      borderColor:"rgba(0, 0, 0, 1)",
      cornerRadius:0,
      caretSize:0,
      caretPadding:10,
    }
  },
  scales: {
    x: {
      grid: {
        display: false
      },
      border : {
        width : 0,
      },
      ticks: {
        color: "rgba(0, 0, 0, 0.6)",
        font: {
          family : "Questrial",
          weight:400,
        },
      }
    },
    y: {
      min:0,
      suggestedMax:10,
      border : {
        width : 0,
      },
      grid: {
        display: true,
        color : "rgba(199, 211, 222, 0.25)",
      },
      ticks: {
        color: "rgba(0, 0, 0, 0.6)",
        font: {
          family : "Questrial",
          weight:400,
        },
      }
    }
  }
};



Moment.locale('fr')

const CompletionChart = (props, context) => {

  const { actLanguage, languageValues } = useContext(LanguageContext)

  const chartRef = useRef();

  const [data, setData] = useState({})

  const [loadChart, setLoadChart] = useState(false)

  /* F10 (retours Hicham 03/09) — palette harmonisee.
   * Les deux couleurs de reperage sont echangees comme demande : l'Icebreaker
   * prend le bleu-gris profond qui servait au Total, le Total prend le cyan qui
   * servait a l'Icebreaker. Les modules suivent un degrade d'une seule famille
   * (violet -> bleu -> bleu-gris -> cyan). Plus aucun rouge ni orange : ils
   * detonnaient avec le reste de l'interface. */
  const COULEUR_ICEBREAKER = '#0C457C'
  const COULEUR_TOTAL = '#94F7FF'
  const COULEURS_MODULES = [
    '#7C6BFF', '#5A7BD8', '#4E8FA8', '#3FB0C4', '#9B7FE6', '#6E93B8',
  ]

  const courbe = (label, color, completionData, epaisseur) => ({
    label : label,
    borderColor: color,
    borderWidth: epaisseur || 2,
    fill: true,
    pointBackgroundColor:color,
    pointHoverBackgroundColor:color,
    backgroundColor: fondDoux(color),
    cubicInterpolationMode: 'monotone',
    data: completionData,
    pointRadius : completionData.map((x, index) => index === (completionData.length-1) ? 3 : 0),
    hitRadius : 10,
  })

  useEffect(() => {
    if (props.completion.length > 0) {
      let datesArr = getDates()

      /* B3 (retours Hicham 03/09) — un plan peut contenir DEUX FOIS le meme
       * contenu (module suivi en annee 1 puis en annee 2). On raisonne donc sur
       * les contenus DISTINCTS : sinon la courbe « Total » comparait le nombre de
       * resultats d'un apprenant a un nombre de lignes de plan plus grand, la
       * condition n'etait jamais vraie et le total restait plat a 0 alors que les
       * 75 apprenants avaient termine. Deux courbes identiques dans la legende
       * disparaissent aussi au passage.
       * Cf JOURNAL-DES-ERREURS.md, motif M7. */
      let modules = []
      const vus = new Set()
      ;(props?.plan || []).forEach((p) => {
        const id = parseInt(p.id)
        if (!Number.isInteger(id) || vus.has(id)) return
        vus.add(id)
        /* F1 : le plan est un instantane, il a fige le nom du contenu au moment de
         * sa creation. On prefere le nom reel remonte par l'API quand il existe.
         * Cf JOURNAL-DES-ERREURS.md, motif M8. */
        const reel = props?.contents?.find((c) => parseInt(c.id) === id)
        modules.push({ id : id, name : reel?.name || p.name })
      })

      const pointsALaDate = (filtre, date) => filtre.filter((el) => {
        return Moment(el.updatedAt).isSameOrBefore(date, 'days')
      }).length

      let dataArr = []
      if (props?.subGroup?.icebreaker) { //pour l'icebreaker
        const idIce = parseInt(props?.subGroup?.icebreaker)
        let filterCompletion = props.completion.filter((el) => parseInt(el.contentID) === idIce)
        let completionData = datesArr.map((date) => pointsALaDate(filterCompletion, date))
        dataArr.push(courbe('ICEBREAKER', COULEUR_ICEBREAKER, completionData))
      }

      modules.forEach((m, index) => {
        let filterCompletion = props.completion.filter((el) => parseInt(el.contentID) === m.id)
        let completionData = datesArr.map((date) => pointsALaDate(filterCompletion, date))
        dataArr.push(courbe(m.name, COULEURS_MODULES[index % COULEURS_MODULES.length], completionData))
      })

      /* B3 (retours Hicham 03/09) — la courbe « Total ».
       *
       * Elle comptait les apprenants ayant termine TOUS les modules, ce qui la
       * placait sous chacune des autres courbes. Deux problemes : elle tombait a
       * zero des qu'un contenu figurait deux fois dans le plan (la condition
       * comparait un nombre de resultats a un nombre de lignes de plan), et elle
       * ne disait pas ce qu'on attend d'un total.
       *
       * Le « Total » est le nombre d'apprenants ayant AVANCE, c'est-a-dire ayant
       * termine au moins un module : c'est l'enveloppe qui coiffe les autres
       * courbes, comme sur le schema de reference. Verifie sur les donnees
       * reelles du groupe 96 : 75 apprenants, ce qui est bien la valeur
       * attendue (« tous les modules termines » n'en donnait que 60).
       */
      if (dataArr.length > 1) {

        let completionData = []
        datesArr.forEach((date) => {
          let filterByDate = props.completion.filter((el) => {
            return Moment(el.updatedAt).isSameOrBefore(date, 'days')
          })

          // un apprenant compte une seule fois, quel que soit son nombre de modules
          let apprenants = new Set()
          filterByDate.forEach((result) => { apprenants.add(result.userID) })
          completionData.push(apprenants.size)

        })

        /* Le Total vaut « au moins un module termine ». Comme l'icebreaker est
           quasiment toujours fait par tout le monde, les deux courbes se
           superposent — et le cyan clair du Total disparaissait sous le
           bleu-gris de l'icebreaker. Trait plus epais, et dessine en dernier :
           il reste lisible sans changer les couleurs demandees (F10). */
        dataArr.push(courbe(
          languageValues?.adminDashboard?.completionChart?.average[actLanguage],
          COULEUR_TOTAL,
          completionData,
          4,
        ))
      }

      let newData = {
        labels : datesArr.map((x) => Moment(x).format('DD/MM/YYYY')),
        datasets: dataArr,
      }

      setData(newData)
    }
  }, [props])

  const getDates = () => {
    //let today = Moment("13/02/2023", "DD/MM/YYYY") //for test

    let planDates = []
    props.plan?.forEach((p) => {
      planDates.push(Moment(p.openDate, "YYYY-MM-DD"))
      planDates.push(Moment(p.closeDate, "YYYY-MM-DD"))
    })
    planDates = planDates.sort((a, b) => a.valueOf() - b.valueOf())

    if (planDates?.length > 0) {
      let firstDate = planDates[0]
      let lastDate = planDates[planDates.length - 1]
      let diffInDays = lastDate.diff(firstDate, 'days', true);
      let diffInWeeks = lastDate.diff(firstDate, 'weeks', true);
      let diffInMonths = lastDate.diff(firstDate, 'months', true);
      /*console.log(diffInDays+ " days for plan")
      console.log(diffInWeeks+ "weeks for plan")
      console.log(diffInMonths+ "months for plan")*/

      let dates=[]
      dates.push(firstDate)

      if (diffInDays <= 7) {
        for (let i=0; i<diffInDays-1; i++) {
          dates.push(Moment(firstDate).add(i+1, 'days'))
        }
      } else if (diffInDays <= 14) {
        for (let i=0; i<diffInDays-1; i++) {
          if (i%2 === 1) {
            dates.push(Moment(firstDate).add(i+1, 'days'))
          }
        }
      } else if (diffInDays <= 28) {
        for (let i=0; i<diffInDays-1; i++) {
          if (i%3 === 0 && i !== 0) {
            dates.push(Moment(firstDate).add(i, 'days'))
          }
        }
      } else {
        if (diffInWeeks > 52) { //plus d'un 1
          for (let i=0; i<diffInDays-1; i++) { //1 date par mois
            if (i%30 === 0 && i !== 0) {
              dates.push(Moment(firstDate).add(i, 'days'))
            }
          }
        } else { //2 date par mois
          for (let i=0; i<diffInDays-1; i++) {
            if (i%15 === 0 && i !== 0) {
              dates.push(Moment(firstDate).add(i, 'days'))
            }
          }
        }
      }

      dates.push(lastDate)

      let finalDates = []
      if (firstDate.isAfter(Moment())) {
        //console.log("on est avant le début du plan")
        setLoadChart(false)
      } else if (lastDate.isSameOrBefore(Moment())) {
        //console.log("on est après la fin du plan")
        finalDates = dates
        setLoadChart(true)
      } else {
        //console.log("on est pendant le plan")
        dates.forEach((date) => {
          if (date.isSameOrBefore(Moment())) {
            finalDates.push(date)
          }
        })
        let haveToAddTodayDate = true
        finalDates.forEach((date) => {
          if (date.isSame(Moment(), 'day') === true) {
            haveToAddTodayDate = false
          }
        })
        if (haveToAddTodayDate === true) {
          finalDates.push(Moment())
        }
        setLoadChart(true)
      }

      return finalDates
    } else {
      return []
    }


  }

  options.plugins.title.text = languageValues?.adminDashboard?.completionChart?.title[actLanguage]

  var chartpluginsset = [
    // D7 review 02/09 : repere vertical « Aujourd'hui », conforme Figma
    {
      afterDatasetsDraw : (chart) => {
        const labels = chart.data.labels || []
        const idx = labels.indexOf(Moment().format('DD/MM/YYYY'))
        if (idx < 0 || !chart.scales?.x) return
        const x = chart.scales.x.getPixelForValue(idx)
        const { top, bottom } = chart.chartArea
        const ctx = chart.ctx
        ctx.save()
        ctx.setLineDash([5, 4])
        ctx.strokeStyle = 'rgba(10,10,11,0.55)'
        ctx.lineWidth = 1.5
        ctx.beginPath(); ctx.moveTo(x, top + 16); ctx.lineTo(x, bottom); ctx.stroke()
        ctx.setLineDash([])
        ctx.font = '13px Questrial'
        ctx.fillStyle = '#0A0A0B'
        ctx.textAlign = 'center'
        ctx.fillText("Aujourd'hui", x, top + 8)
        ctx.restore()
      }
    },
    {
      afterEvent :(chart, args, pluginOptions) => {
        const event = args.event;
        if (event.type === 'mouseout') {
          if (actFocusIndex !== null) {
            chart.data.datasets[actFocusIndex].backgroundColor = fondDoux(chart.data.datasets[actFocusIndex].borderColor)
            actFocusIndex = null
            chart.update()
          }
        }
      },
    }
  ];

  return (
    <>
      {loadChart === true && props.dataLoaded === true && props.completion.length > 0 ? (
        <>
          <Line
            ref={chartRef}
            options={options}
            plugins={chartpluginsset}
            data={{
              datasets: data.datasets || [],
              labels : data.labels || [],
            }}
          />
        </>
      ) : (
        <Box sx={{flex:1, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", gap:"15px"}}>
          <Box sx={{
            width:["50px", "60px", "60px", "75px"],
            minWidth:["50px", "60px", "60px", "75px"],
          }}>
            <img src={noCompletionChartIcon} style={{width:"100%"}}/>
          </Box>
          <Box sx={{
            color:"text.black",
            fontSize:["20px", "24px", "24px", "26px"],
            textAlign:"center",
          }}>
            {languageValues?.adminDashboard?.completionChart?.emptyTitle[actLanguage]}
          </Box>
          <Box sx={{
            color:"text.subTitle",
            fontSize:["15px", "16px", "16px", "17px"],
            textAlign:"center",
            maxWidth:"300px",
          }}>
            {languageValues?.adminDashboard?.completionChart?.emptySubTitle[actLanguage]}
          </Box>
        </Box>
      )}
    </>
  )
}


export default CompletionChart
